export const ALL = "ALL";
export const ALL_SPECIFICATIONS = "ALL_SPECIFICATIONS";
export const PUBLICATIONS = "PUBLICATIONS";
export const LAST_UPDATES = "LAST_UPDATES";
//export const LAST_SPECIFICATIONS = "LAST_SPECIFICATIONS";

export const ALL_SPECIFICATIONS_REVERSE = "ALL_SPECIFICATIONS_REVERSE";
export const PUBLICATIONS_REVERSE = "PUBLICATIONS_REVERSE";
export const LAST_UPDATES_REVERSE = "LAST_UPDATES_REVERSE";

export const SET_TERM = "SET_TERM";
export const SET_DATE = "SET_DATE";
export const SET_ALL_DATES = "SET_ALL_DATES";
export const SET_RELEVENT_FILES = "SET_RELEVENT_FILES";
export const DISPLAY_BY_CHAPTER = "DISPLAY_BY_CHAPTER";
export const SELECT_AGGREGATION = "SELECT_AGGREGATION";
export const SELECT_ALL_AGGREGATIONS = "SELECT_ALL_AGGREGATIONS";
export const SET_SEARCH_RESULTS = "SET_SEARCH_RESULTS";
export const SEARCH = "SEARCH";
export const CLEAR_DATA = "CLEAR_DATA";
export const SET_DISPLAY_SPINNER = "SET_DISPLAY_SPINNER";

export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
